import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";

const LEGAL_LINKS = [
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/refund-policy", label: "Refunds" },
  { to: "/disclaimer", label: "Disclaimer" },
  { to: "/seller-information", label: "Seller Information" },
];

const EFFECTIVE_DATE = "18 October 2026";
const LAST_UPDATED = "18 October 2026";

/**
 * Shared chrome for the compliance pages: top legal nav, header with the
 * standard effective/updated meta, optional "short version" summary, a
 * sticky table of contents, the section body, and the legal footer.
 *
 * Props:
 *   title      page title
 *   activePath current route (to mark the active top nav link)
 *   summary    optional array of strings for the "short version" box
 *   toc        array of { id, label } for the contents list
 *   children   the <section className="tc__sec"> blocks
 */
export default function LegalLayout({ title, activePath, summary, toc, children }) {
  return (
    <Layout>
      <main className="tc">
        <header className="tc__head">
          <nav className="tc__nav-top" aria-label="Legal pages">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} aria-current={activePath === l.to ? "page" : undefined}>
                {l.label}
              </Link>
            ))}
          </nav>
          <h1 className="tc__title">{title}</h1>
          <p className="tc__meta">
            Effective date: {EFFECTIVE_DATE} &nbsp;|&nbsp; Last updated: {LAST_UPDATED}
          </p>
          {summary && summary.length ? (
            <div className="tc__summary">
              <h2>The short version</h2>
              <ul>
                {summary.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
              <p>This summary is for convenience only. The full text below is what applies.</p>
            </div>
          ) : null}
        </header>

        <div className="tc__layout">
          {toc && toc.length ? (
            <nav className="tc__toc" aria-label="Contents">
              <p className="tc__toc-title">Contents</p>
              <ol>
                {toc.map((t) => (
                  <li key={t.id}>
                    <a href={`#${t.id}`}>{t.label}</a>
                  </li>
                ))}
              </ol>
            </nav>
          ) : null}

          <div className="tc__body">{children}</div>
        </div>
      </main>
    </Layout>
  );
}
